import { ICurrency } from '@/types/Currency';

export const getCurrency = (key: string) => {
  return currencies[key];
};

export const formatCurrency = (value = 0, currency: ICurrency): string => {
  const formattedValue = getFormattedCurrencyString(value);
  if (!currency) {
    return formattedValue;
  }
  return currency.position === 0
    ? `${currency.symbol}${formattedValue}`
    : `${formattedValue} ${currency.symbol}`;
};

const getFormattedCurrencyString = (value: number) => {
  return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
};

const currencies = {
  USD: {
    name: 'Dollar',
    symbol: '$',
    position: 0,
    description: 'US Dollar',
    key: 'USD',
  },
  EUR: {
    name: 'Euro',
    symbol: '€',
    position: 1,
    description: 'Euro',
    key: 'EUR',
  },
  GBP: {
    name: 'Pound',
    symbol: '£',
    position: 0,
    description: 'British Pound',
    key: 'GBP',
  },
  CAD: {
    name: 'Dollar',
    symbol: '$',
    position: 0,
    description: 'Canadian Dollar',
    key: 'CAD',
  },
  HKD: {
    name: 'Dollar',
    symbol: 'HK$',
    position: 0,
    description: 'Hong Kong Dollar',
    key: 'HKD',
  },
  SGD: {
    name: 'Dollar',
    symbol: 'S$',
    position: 0,
    description: 'Singapore Dollar',
    key: 'SGD',
  },
  CHF: {
    name: 'Franc',
    symbol: 'CHF',
    position: 0,
    description: 'Swiss franc',
    key: 'CHF',
  },
  JPY: {
    name: 'Yen',
    symbol: '¥',
    position: 0,
    description: 'Japanese Yen',
    key: 'JPY',
  },
  SEK: {
    name: 'Krona',
    symbol: 'kr',
    position: 1,
    description: 'Svenska kronor',
    key: 'SEK',
  },
  DKK: {
    name: 'Krone',
    symbol: 'kr',
    position: 1,
    description: 'Danske kroner',
    key: 'DKK',
  },
  NOK: {
    name: 'Krone',
    symbol: 'kr',
    position: 1,
    description: 'Norske kroner',
    key: 'NOK',
  },
  BRL: {
    name: 'Real',
    symbol: 'R$',
    position: 0,
    description: 'Brazilian real',
    key: 'BRL',
  },
  INR: {
    name: 'Rupee',
    symbol: '₹',
    position: 0,
    description: 'Indian rupee',
    key: 'INR',
  },
  CNY: {
    name: 'Yuan',
    symbol: '¥',
    position: 0,
    description: 'Renminbi',
    key: 'CNY',
  },
  ZAR: {
    name: 'Rand',
    symbol: 'R',
    position: 0,
    description: 'South African Rand',
    key: 'ZAR',
  },
  AUD: {
    name: 'Dollar',
    symbol: '$',
    position: 0,
    description: 'Australian Dollar',
    key: 'AUD',
  },
  THB: {
    name: 'Bath',
    symbol: '฿',
    position: 0,
    description: 'Thai Baht',
    key: 'THB',
  },
  PLN: {
    name: 'Zloty',
    symbol: 'zł',
    position: 1,
    description: 'Polish Złoty',
    key: 'PLN',
  },
  KWH: {
    name: 'Kilowatt hour',
    symbol: 'kWh',
    position: 1,
    description: 'Kilowatt hour',
    key: 'KWH',
  },
  CBM: {
    name: 'Cubic meter',
    symbol: 'm³',
    position: 1,
    description: 'Cubic meter',
    key: 'CBM',
  },
};
